import { Link, useNavigate, useParams } from 'react-router-dom';
import backicon from '../../assets/images/back.png';
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from 'react';
import { getMembersDetails } from '../../slices/member';
import { useTranslation } from 'react-i18next';

const MemberDetails = () => {
    const { id } = useParams();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { member } = useSelector((state) => state.member);
    const { user } = useSelector((state) => state.auth);

    const { t } = useTranslation();
    useEffect(() => {
        if (user && user.approve == "N") {
            navigate('/profile');
        }

        dispatch(getMembersDetails(id));
    }, []);
    return (
        <div className="container memberDetails">
            <section className="mt-5 pt-5">
                <div className="row">
                    <div className='col-md-12'>
                        <Link to='/members' className='back-link'>
                            <img src={backicon} style={{ width: "auto" }} />
                        </Link>
                    </div>
                    <div className='col-md-12 mt-2-5'>
                        <div className='section-title'>
                            <h1><span className='font-color-1'>{t('memberDetails')}</span></h1>
                            <p className='mb-0'>{t('section_text1')}<br />{t('section_text2')}</p>
                        </div>
                    </div>
                    <div className='card bg-2 mt-2-5'>
                        <div className='card-body p-2-new'>
                            <div className='row'>
                                <div className='col-md-6 p-0'>
                                    <div className='table-area job-details font-color'>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>{t('name_of_the_head')}</td>
                                                    <td>{member?.head_name}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('village')}</td>
                                                    <td>{member?.village}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('block')}</td>
                                                    <td>{member?.block}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('district')}</td>
                                                    <td>{member?.district}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('contact_no')}</td>
                                                    <td>{member?.phone_number}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('birth_year')}</td>
                                                    <td>{member?.birth_year}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('occupation')}</td>
                                                    <td>
                                                        {member?.occupation == 'Business' ? t('govt') :  '' }   
                                                        {member?.occupation == 'Private' ? t('pvt') :  '' }   
                                                        {member?.occupation == 'Government' ? t('govt') :  '' }    
                                                    </td>
                                                </tr>
                                                {
                                                    member?.occupation != "Business" &&
                                                    <>
                                                        <tr>
                                                            <td>{t('department')}</td>
                                                            <td>{member?.department}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t('position')}</td>
                                                            <td>{member?.position}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t('joining_date')}</td>
                                                            <td>{member?.joining_date}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t('location')}</td>
                                                            <td>{member?.location}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t('post_tenure')}</td>
                                                            <td>{member?.post_tenure}</td>
                                                        </tr>
                                                    </>
                                                }

                                                {
                                                    member?.occupation == "Business" &&
                                                    <tr>
                                                        <td>{t('business_name')}</td>
                                                        <td>{member?.business_name}</td>
                                                    </tr>
                                                }


                                                <tr>
                                                    <td>{t('other_post')}</td>
                                                    <td>{member?.other_post}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('other_post_tenure')}</td>
                                                    <td>
                                                    {member?.other_post_duration == 'Current' ? t('current') :  '' } 
                                                    {member?.other_post_duration == 'Past' ? t('past') :  '' } </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className='col-md-6 p-0'>
                                    <div className='table-area job-details font-color'>
                                        <table>
                                            <tbody>
                                                <tr>
                                                    <td>{t('father_name')}</td>
                                                    <td>{member?.father_name}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('mother_name')}</td>
                                                    <td>{member?.mother_name}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('grandfather_name')}</td>
                                                    <td>{member?.grand_father_name}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('grandmother_name')}</td>
                                                    <td>{member?.grand_mother_name}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('marital_status')}</td>
                                                    <td>
                                                    {member?.marital_status == 'UnMarried' ? t('unMarried') :  '' }   
                                                        {member?.marital_status == 'Married' ? t('married') :  '' }      
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>{t('cast')}</td>
                                                    <td>{member?.cast}</td>
                                                </tr>
                                                <tr>
                                                    <td>{t('education')}</td>
                                                    <td>
                                                    {member?.education == 'Below Metric' ? t('belowMetric') :  '' }   
                                                    {member?.education == 'Metric' ? t('Metric') :  '' } 
                                                    {member?.education == 'Graduate' ? t('graduate') :  '' }   
                                                    {member?.education == 'Post Graduate' ? t('postGraduate') :  '' } 
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {member?.marital_status == 'Married' ?
                        <>
                            <div className='card bg-2 mt-2-5'>
                                <div className='card-body p-2-new'>
                                    <div className='row'>


                                        <div className='col-md-6 p-0'>
                                            <div className='table-area job-details font-color'>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td colspan="2"><h4 className='detailsHeading'>{t('detail_son_doughter')}</h4></td>
                                                        </tr>
                                                        {
                                                            member?.details?.map((item, index) => {
                                                                return (<tr>
                                                                    <td>{item.type} - {item.name}</td>
                                                                    <td>{item.dob}</td>
                                                                </tr>);
                                                            })
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className='card bg-2 mt-2-5'>
                                <div className='card-body p-2-new'>
                                    <div className='row'>
                                        <div className='col-md-6 p-0'>
                                            <div className='table-area job-details font-color'>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td colspan="2"><h4 className='detailsHeading'>{t('details_of_maternal_house')}</h4></td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t('village')}</td>
                                                            <td>
                                                                {member?.maternal_village}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t('name')}</td>
                                                            <td>{member?.maternal_name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t('relationship')}</td>
                                                            <td>{member?.maternal_relationship}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>{t('phone_number')}</td>
                                                            <td>{member?.maternal_phone}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* <div className='col-md-6 p-0'>
                                <div className='table-area job-details font-color'>
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td colspan="2"><h4 className='detailsHeading'>Details of In Law House</h4></td>
                                            </tr>
                                            <tr>
                                                <td>Village</td>
                                                <td>Test</td>
                                            </tr>
                                            <tr>
                                                <td>Name</td>
                                                <td>Test</td>
                                            </tr>
                                            <tr>
                                                <td>Relationship</td>
                                                <td>test</td>
                                            </tr>
                                            <tr>
                                                <td>Phone Number</td>
                                                <td>test</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div> */}
                                    </div>
                                </div>
                            </div>
                        </>
                        : ''}



                </div>
            </section>
        </div>
    );
}
export default MemberDetails;